// filterAndReduceVoucherAmount.js

// Function to filter voucher details by month and reduce the amount
const filterAndReduceVoucherAmountMonthly = (
  voucherDetailsList,
  targetMonth,
  targetYear = undefined
) => {
  // Get current year if not provided
  if (!targetYear) {
    targetYear = new Date().getFullYear();
  }

  // Filter vouchers for the target month and year
  const filteredVouchers = voucherDetailsList.filter((voucher) => {
    const voucherDate = new Date(voucher.voucherPurchaseDate);
    const voucherMonth = voucherDate.getMonth() + 1; // +1 because getMonth() returns zero-based index
    const voucherYear = voucherDate.getFullYear();
    return voucherMonth === targetMonth && voucherYear === targetYear;
  });

  // Reduce the amount of filtered vouchers
  const reducedAmount = filteredVouchers.reduce((total, voucher) => {
    debugger;
    // Assuming voucher amount is in voucher.amount
    return total + voucher.voucherAmount;
  }, 0);

  return reducedAmount;
};

export default filterAndReduceVoucherAmountMonthly;
